<div
  class="flex items-center flex-row"
  [ngClass]="{ 'justify-center': center, 'justify-start': !center }"
>
  <div class="checkbox-wrapper group w-7 h-7 mr-2">
    <div
      class="w-6 h-7 top-0 left-0 absolute flex justify-center items-center transition-all duration-200"
      [ngClass]="{ 'opacity-0': valor() }"
    >
      <div
        class="w-[28px] h-[24px] rounded-full border-2 border-primary-900"
      ></div>
    </div>
    <input type="checkbox" [(ngModel)]="valor" [disabled]="readonly" />
    <svg viewBox="0 0 35.6 35.6">
      <circle class="background" cx="17.8" cy="17.8" r="17.8"></circle>
      <circle class="stroke" cx="17.8" cy="17.8" r="14.37"></circle>
      <polyline
        class="check"
        [ngClass]="{ 'check-hover': !valor() && !readonly }"
        points="11.78 18.12 15.55 22.23 25.17 12.87"
      ></polyline>
    </svg>
  </div>
  <p>{{ etiqueta }}</p>
</div>
